<template>
    <div id="record_cover">
        <div class="record_cover1">
            <div class="record_title">
                <div>封面记录</div>
                <div class="record_title1" v-if="imgList.length > 0" @click="openDel">
                    <div v-if="delShow">
                        完成
                    </div>
                    <div class="record_title1_1" v-else>
                        <img src="../assets/image/icon_create8.png" alt="">
                        管理
                    </div>

                </div>
            </div>
            <div class="record_cover3" v-if="imgList.length == 0">
                <noData :noIndex="4"></noData>
            </div>
            <div class="record_cover3" v-else>
                <div :class="imgIndex == i ? 'record_cover3_1 record_cover3_2' : 'record_cover3_1 '"
                    v-for="(item, i) in imgList" :key="i" @click="select(i)">
                    <img :src="item.resultUrl" alt="">
                    <div v-if="delShow" class="record_cover3_3" @click.stop="deleteImage(i)">
                        <img src="../assets/image/icon_del1.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="record_cover2" v-if="imgList.length > 0">
            <div class="record_cover2_1">
                <img :src="imgList[imgIndex].resultUrl" alt="">
            </div>
            <div class="record_cover2_2" @click="download">点击下载</div>
        </div>
        <delPpopup ref="delPpopup" @confirm="confirm"></delPpopup>
    </div>
</template>

<script>
import noData from './no_data.vue';
import delPpopup from './del_popup.vue';
import { EventBus } from '@/utils/eventBus';
import api from '@/api/api';
import axios from 'axios';
export default {

    components: {
        noData, delPpopup
    },
    data() {
        return {
            imgList: [],
            imgIndex: 0, // 图片下标
            delShow: false,
            delIndex: null, //删除index
            pageNum: 1, //当前页
        }
    },
    mounted() {
        EventBus.$on('coverPagenum', (i) => {
            this.imgIndex = 0
            this.pageNum = i
            this.getAiCover(i)
        });
    },
    beforeDestroy() {
        EventBus.$off('coverPagenum');
    },
    created() {
        this.getAiCover(1)
    },
    methods: {
        // 选择图片
        select(i) {
            this.imgIndex = i;
        },
        // 管理删除
        openDel() {
            this.delShow = !this.delShow;
        },
        getAiCover(num) {
            api.getAiCover(num, 10).then((res) => {
                // console.log(res)
                if (res.code == 200) {
                    this.imgList = res.rows
                    this.$emit('getTotal', res.total)
                }
            })
        },
        // 删除图片
        deleteImage(i) {
            // EventBus.$emit('openPrompt', 0)
            this.$refs.delPopup.openPrompt(0)
            this.delIndex = i
        },
        //确认删除
        confirm() {
            api.delCover(this.imgList[this.delIndex].id).then((res) => {
                if (res.code == 200) {
                    this.imgList.splice(this.delIndex, 1);
                    if (this.imgIndex >= this.imgList.length) {
                        this.imgIndex = this.imgList.length - 1;
                    }
                    this.getAiCover(this.pageNum)
                    this.$message.success(`删除成功！`)
                }
            })

        },
        // download() {
        //     const imageUrl = this.imgList[this.imgIndex].resultUrl;
        // },
        async download() {
            this.isDownloading = true;
            const imageUrl = this.imgList[this.imgIndex].resultUrl
            try {
                const response = await axios.get(imageUrl, {
                    responseType: 'blob',
                    headers: {
                        // 若服务器需要认证，可在此添加认证信息
                        // 'Authorization': 'Bearer your_token'
                    },
                });

                const blob = new Blob([response.data], { type: 'image/png' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'image.png';

                // 对于不支持 download 属性的浏览器的兼容处理
                if (typeof link.download === 'undefined') {
                    link.target = '_blank';
                }

                document.body.appendChild(link);
                link.click();

                URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
            } catch (error) {
                console.error('图片下载失败:', error);
                // 可以使用 Vue 2 的消息提示插件（如 Element UI 的 this.$message）来提示用户
                this.$message && this.$message.error('图片下载失败，请稍后重试');
            } finally {
                this.isDownloading = false;
            }
        }
    }
}
</script>

<style>
#record_cover {
    width: 100%;
    height: 100%;
    display: flex;
    background-color: #FFF8F2;
}

.record_title1 {
    display: flex;
    align-items: center;
    font-weight: 400;
    cursor: pointer;
}

.record_title1 img {
    width: 19px;
    height: 19px;
    margin-right: 5px;
}

.record_title1_1 {
    display: flex;
    align-items: center;
}

.record_cover1 {
    width: 100%;
    padding: 35px 25px;
}

.record_cover1 {
    flex: 1;
    background: #FFFFFF;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 13px 13px 13px 13px;
}

.record_cover2 {
    width: 404px;
    height: 100%;
    background: #FFFFFF;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 13px 0 0 13px;
    margin-left: 13px;
}

.record_cover3 {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-height: calc(100% - 30px);
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    row-gap: 17px;
    column-gap: 17px;
}

.record_cover3_1 {
    width: 133px;
    height: 173px;
    background: rgba(17, 17, 17, 0.4);
    border-radius: 8px;
    overflow: hidden;
    position: relative;
}

.record_cover3_2 {
    border: 2px solid #FF8802;
}

.record_cover3_1 img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.record_cover3_3 {
    position: absolute;
    top: 0;
    left: 0;
    width: 133px;
    height: 173px;
    background-color: rgba(17, 17, 17, 0.4);
    z-index: 10;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.record_cover3_3 img {
    width: 29px;
    height: 29px;
}

.record_cover2 {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
}

.record_cover2_1 {
    width: 345px;
    height: 448px;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 20px;
}

.record_cover2_1 img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.record_cover2_2 {
    width: 167px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    background: var(--tech-primary);
    border-radius: 8px;
    font-size: 16px;
    color: #FFFFFF;
    cursor: pointer;
}
</style>